import {
  BHTsINSURANCEPROVIDERS_TABLE,
  GET_BHTsINSURANCEPROVIDERS_LIST_PENDING,
  GET_BHTsINSURANCEPROVIDERS_LIST_FULFILLED,
  GET_BHTsINSURANCEPROVIDERS_LIST_REJECTED,
  GET_BHTsINSURANCEPROVIDER_PENDING,
  GET_BHTsINSURANCEPROVIDER_FULFILLED,
  GET_BHTsINSURANCEPROVIDER_REJECTED,
  DELETE_BHTsINSURANCEPROVIDER_FULFILLED,
  DELETE_BHTsINSURANCEPROVIDER_PENDING,
  ADD_BHTsINSURANCEPROVIDER_FULFILLED,
  UPDATE_BHTsINSURANCEPROVIDER_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'BHTs Insurance Providers',
  tablename: BHTsINSURANCEPROVIDERS_TABLE,
  bhtsinsuranceproviders: [],
  loadingList: false,
  errors: []
}
const reducerBHTsInsuranceProviders = (state = initialState, action) => {
  var dataUndefinedTestReturn
  switch (action.type) {
    case GET_BHTsINSURANCEPROVIDER_PENDING:
    case GET_BHTsINSURANCEPROVIDERS_LIST_PENDING:
    case DELETE_BHTsINSURANCEPROVIDER_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_BHTsINSURANCEPROVIDERS_LIST_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        bhtsinsuranceproviders: dataUndefinedTestReturn
      }
      break
    case GET_BHTsINSURANCEPROVIDER_FULFILLED:
      dataUndefinedTestReturn =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        bhtsinsuranceproviders: dataUndefinedTestReturn
      }
      break
    case DELETE_BHTsINSURANCEPROVIDER_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_BHTsINSURANCEPROVIDER_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_BHTsINSURANCEPROVIDER_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_BHTsINSURANCEPROVIDERS_LIST_REJECTED:
    case GET_BHTsINSURANCEPROVIDER_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break

    default:
      return state
  }
  return state
}
export default reducerBHTsInsuranceProviders
